import React, { useCallback } from 'react';
import Wrapper from '../Wrapper';
import Select from '../Select';
import Text from '../Text';

type LanguageSelectorPropsType = {
  locales: { [key: string]: string };
  locale?: string;
  changeLocale?: (locale: string) => {};
  lable?: string;
  lableSize?: 1 | 2 | 3 | 4;
};

const LanguageSelector: React.FC<LanguageSelectorPropsType> = ({
  locales,
  locale,
  changeLocale = () => {},
  lable,
  lableSize = 2,
}) => {
  const handleClickLocale = useCallback(
    (value) => {
      changeLocale(value);
    },
    [changeLocale],
  );

  return (
    <>
      {!!lable && (
        <Wrapper mb={2}>
          <Text semiBold level={lableSize}>
            {lable}
          </Text>
        </Wrapper>
      )}
      <Select
        defaultValue={locale}
        onChange={handleClickLocale}
        style={{ width: '100%' }}
        options={Object.keys(locales).map((key) => ({
          key: locales[key],
          value: key,
        }))}
        useDefaultWrapper
      />
    </>
  );
};

export default LanguageSelector;
